import { isString } from 'lodash';

import i18n from 'src/locales/i18n';

import { BusinessErrorCodes } from 'src/types/business-errors';



export const generateListCreateError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.ResourceNotFound) {
      return i18n.t('jobs.action.api.not_found');
    }
  }
  return i18n.t('lists.api.create.default_error');
};

export const generateListUpdateError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.ResourceNotFound) {
      return i18n.t('jobs.action.api.not_found');
    }
  }
  return i18n.t('lists.api.update.default_error');
};